module.exports = __webpack_public_path__ + "pn.414db632aa971d3b811d.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/pn.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/pn.svg
// module chunks = styles